import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { Button, Card, ContentSection, Fieldset, Layout, Paragraph, SectionHeading } from '@vwfs-bronson/bronson-react';
import { subpagesNavigationList } from '../../../../resources/base/models';
import { KnownSearchParams } from '../../../../resources/base/models/enums';
import { removeSearchParamsFromUrl } from '../../../../services/common/miscUtils';
import { useRemoveCardTitle } from '../../../../services/common/useRemoveCardTitle';
import { resetQuoteSpecificReduxData } from '../../../../services/redux';
import {
  setRunningContractStatus,
  setSubPageLabelStatusIds,
} from '../../../../services/redux/features/dashboard.slice';
import { loadingActions } from '../../../../services/redux/features/loading.slice';
import { setFilters } from '../../../../services/redux/features/notes.slice';
import { useNavigate } from '../../../../services/routing/navigate';
import { notesFiltersInitialValues } from '../../../NotesPage/Filters';
import { getStatusIdsBySubpage, OfferStatusIdType, SubpageLabelType } from '../../constants/StatusMap';
import { RunningContractStatusType } from '../utils/searchedValues.types';

type SortByType = 'read' | 'unread';

const messagesMap: Record<string, SortByType> = {
  'Messages lus': 'read',
  'Messages non lus': 'unread',
};

const runningContractStatusMap: Record<string, RunningContractStatusType> = {
  Activé: RunningContractStatusType.ACTIVE,
  Payé: RunningContractStatusType.PAID,
};

export const DashboardSubpageActiveQuotes: FunctionComponent = () => {
  const navigate = useNavigate();
  useRemoveCardTitle();
  const { state } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!state?.navigatedFromHeader) {
      return;
    }

    dispatch(loadingActions.setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.navigatedFromHeader]);

  useEffect(() => {
    resetQuoteSpecificReduxData();
    removeSearchParamsFromUrl(KnownSearchParams.cid);
  });

  return (
    <ContentSection pageWrap className="u-pv-none">
      <Fieldset>
        {subpagesNavigationList?.map(({ label, link, descriptionList, index }) => (
          <ContentSection className="u-pt u-pb" key={index}>
            <Layout.Item default="1/1">
              <Fieldset.Row>
                <SectionHeading className="u-float-left" level={3}>
                  {label}
                </SectionHeading>{' '}
                <Button
                  ariaLabel="Go to all items"
                  className="u-float-right"
                  secondary
                  simple
                  icon="chevron-right"
                  onClick={() => navigate.url(link)}
                />
              </Fieldset.Row>
            </Layout.Item>
            <Card title="">
              <Layout.Item default="1/1">
                {descriptionList?.items?.map((item: SubpageLabelType) => {
                  const quoteStatusIds: OfferStatusIdType[] = getStatusIdsBySubpage(item);
                  return (
                    // eslint-disable-next-line react/jsx-key
                    <Fieldset.Row>
                      <Layout>
                        <Layout.Item default="11/12" s="3/4" className="u-text-left">
                          <Paragraph> {item} </Paragraph>
                        </Layout.Item>
                        <Layout.Item default="1/12" s="1/4">
                          <Button
                            ariaLabel="Edit row entry"
                            link
                            simple
                            icon="chevron-right"
                            onClick={() => {
                              if (messagesMap[item]) {
                                dispatch(setFilters({ ...notesFiltersInitialValues, sortBy: messagesMap[item] }));
                              }

                              if (['Activé', 'Payé'].includes(item)) {
                                dispatch(setRunningContractStatus(runningContractStatusMap[item]));
                              }

                              dispatch(setSubPageLabelStatusIds(quoteStatusIds));
                              navigate.url(link);
                            }}
                          />
                        </Layout.Item>
                      </Layout>
                    </Fieldset.Row>
                  );
                })}
              </Layout.Item>
            </Card>
          </ContentSection>
        ))}
      </Fieldset>
    </ContentSection>
  );
};
